module.exports = __webpack_public_path__ + "img/login-splash.8222b1af.svg";